import EducationContent from './educationContent'

export default EducationContent